import React, { useState } from 'react';
import Header from './Components/Header';
import Scroll from './Components/Scroll';
import Sidebar from './Components/Sidebar';
const Layout = ({ children }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen((prev) => !prev);
    };
    return (
        <>
            <Scroll />
            <Header toggleSidebar={toggleSidebar} />
            <div className="container-scroller">
                <div className="container-fluid page-body-wrapper">
                    <Sidebar isOpen={isSidebarOpen}  toggleSidebar={toggleSidebar}/>
                    <div className="main-panel">
                        {children}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Layout;
